import React, { PropsWithChildren, createContext, useContext } from 'react';

import { usePersistentState } from '../hooks/usePersistentState';

export type Qualification =
  | 'DISQUALIFIED'
  | 'QUALIFIED_CALENDLY'
  | 'QUALIFIED_EMAILED'
  | undefined;

type QualificationContext = {
  embryoAssistQualification: Qualification;
  setEmbryoAssistQualification: React.Dispatch<
    React.SetStateAction<Qualification>
  >;
};
const QualificationContext = createContext<QualificationContext>({
  embryoAssistQualification: undefined,
  setEmbryoAssistQualification: () => {},
});

export const QualificationProvider = (props: PropsWithChildren) => {
  const [embryoAssistQualification, setEmbryoAssistQualification] =
    usePersistentState<Qualification>({
      serializationKey: 'embryoAssistQualification',
      defaultValue: undefined,
    });

  return (
    <QualificationContext.Provider
      value={{ embryoAssistQualification, setEmbryoAssistQualification }}
    >
      {props.children}
    </QualificationContext.Provider>
  );
};

export const useQualification = () => useContext(QualificationContext);
